import React, { useState, useEffect } from "react";
import logo from "../images/new_logo.png";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaBars, FaSun, FaMoon } from "react-icons/fa";

const Navbar = ({ value, setValue, click, setClick, theme, toggleTheme }) => {
  const location = useLocation();
  const [navBar, setNavBar] = useState({ windowPosition: window.pageYOffset });
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleScroll = () => {
    const windowPosition = window.pageYOffset;
    const scrollable =
      document.documentElement.scrollHeight - window.innerHeight;
    const progress = scrollable > 0 ? (windowPosition / scrollable) * 100 : 0;

    setNavBar({ windowPosition });
    setScrollProgress(progress);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <motion.nav
      exit={{ opacity: 0, x: "-100vw", transition: "easeInOut" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      onScroll={handleScroll}
      className={
        navBar.windowPosition > 100 ? "navbar-fixed nav nav-bg " : "nav"
      }
      id="nav"
    >
      <div className="nav-center">
        <div className="nav-header">
          <Link to="/">
            <motion.img
              initial={{ rotateY: 0 }}
              animate={{ rotateY: 360 }}
              transition={{
                ease: "easeInOut",
                duration: 2,
                flip: Infinity,
                repeatDelay: 5,
              }}
              src={logo}
              className="nav-logo"
              alt="logo"
            />
          </Link>
          <motion.button
            className="nav-btn"
            id="nav-btn"
            onClick={() => {
              setClick(!click);
              setValue(!value);
            }}
          >
            <FaBars />
          </motion.button>
        </div>
        <motion.button
          className="theme-toggle"
          onClick={toggleTheme}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <FaSun /> : <FaMoon />}
        </motion.button>
        <ul className="nav-links hero-icon">
          <li>
            <Link
              to="/"
              id="Home"
              className={location.pathname === "/" ? "a active" : "a"}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={location.pathname === "/about" ? "a active" : "a"}
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/experience"
              className={location.pathname === "/experience" ? "a active" : "a"}
            >
              Experience
            </Link>
          </li>
          <li>
            <Link
              to="/projects"
              className={location.pathname === "/projects" ? "a active" : "a"}
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              to="/education"
              className={location.pathname === "/education" ? "a active" : "a"}
            >
              Education
            </Link>
          </li>
          <li>
            <Link
              to="/contact"
              id="contact"
              className={location.pathname === "/contact" ? "a active" : "a"}
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>
      <div className="scroll-progress" aria-hidden="true">
        <span
          className="scroll-progress-bar"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>
    </motion.nav>
  );
};
export default Navbar;
